import React, {Component} from 'react';
import {Row, Container} from './layoutComponents';
import {Paper, MenuBar, HeaderContainer, HeroHeaderImg, HeaderText, MenuText, Form, SubmitButton, InputField, FormLabel, QuoteBlock, Quote, Quotation, HintHolder, MouseText} from './styledComponents';


export class Settings extends Component{
  constructor(props){
    super(props);
    this.state={
      email:"",
      password:"",
      errors: {}
    }
  }
  onChange(evt){
    this.setState({[evt.target.name]:evt.target.value});

        const validity = evt.target.validity;

        if(!validity.valid){
          this.setState({
            errors: {[evt.target.name+"Error"]: true}
          })
        }else{
          this.setState({
            errors: {[evt.target.name+"Error"]: false}
          })
        }
  }

  signInWithEmailAndPassword({email, password}){
    this.props.onLogin(email, password);
  }
  createUserWithEmailAndPassword({email, password}){
      //this should just update data
    //return firebase.auth().createUserWithEmailAndPassword(email, password);
    this.props.onRegister(email, password);
  }
  onSubmit(evt){
    console.log("SUBMITTING..........")
    evt.preventDefault();

    //for better validation, see advanced example
    if(this.state.email && this.state.password){
      switch(evt.target.value){
        case "Log In":
          this.signInWithEmailAndPassword(this.state);
        break;
        case "Register":

          this.createUserWithEmailAndPassword(this.state);
        break;
        default:
          console.log("Incorrect target value")
       }
    }
  }
  render(){
    return(
      <div>
        {this.props.authenticated ? <LogoutForm action={this.signOut.bind(this)} /> : <LoginForm onSubmit={this.onSubmit.bind(this)} onChange={this.onChange.bind(this)} email={this.state.email} password={this.state.password} showHintEmail={this.state.errors.emailError} showHintPassword={this.state.errors.passwordError} />}
      </div>
    )
  }
}
export const LoginForm = props =>{
  return (
    <Container>
      <HeaderContainer>
      <HeroHeaderImg background="https://firebasestorage.googleapis.com/v0/b/leafletv2.appspot.com/o/theme-assets%2Fleaflet_landing-04.png?alt=media&token=3c2bf1ce-5050-4ef5-bd45-a8950c3d1e30">
        <HeaderText headerTextColour="white" headerTextWidth="70%">Talk is cheap. Show me the code.</HeaderText>
      </HeroHeaderImg>
      </HeaderContainer>
      <Paper paperPadding="0px" colWidth="50%" colMaxWidth="400px" colWidthSm="90%">
        <MenuBar connected>
          <MenuText>Log in or Register</MenuText>
        </MenuBar>
        <div className="info">
      <Form>
        <label>
          <FormLabel>Email:</FormLabel>
          <HintHolder>
              {props.showHintEmail && <MouseText mousePos="absolute">Please use a valid email</MouseText>}
          <InputField onChange={props.onChange} name="email" type="text" value={props.email} required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"/>
          </HintHolder>
        </label>
        <label>
          <FormLabel>Password:</FormLabel>
          <HintHolder>
              {props.showHintPassword && <MouseText mousePos="absolute">Minimum 6 characters</MouseText>}
          <InputField onChange={props.onChange} name="password" type="password" value={props.password} required pattern=".{6,}" />
          </HintHolder>
        </label>
        <Row rowJustify="space-around">
          <SubmitButton type="submit" value="Log In" onClick={props.onSubmit} >Log In</SubmitButton>
          <SubmitButton type="submit" value="Register" onClick={props.onSubmit} >Register</SubmitButton>
        </Row>
      </Form>
        </div>
      </Paper>
      <QuoteBlock><Quote><Quotation className="icon-quote-left"></Quotation>To code, or not to code, that is the wrong question.</Quote></QuoteBlock>
    </Container>
    )
}
export const LogoutForm = props =>{
  return (
    <button onClick={props.action}>Log Out</button>
  )
}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/settings.js